import Api from '@/api'
const resource = 'invitations'

export default {
  createInvitation (invitation) {
    return Api.post(`/${resource}`, { invitation })
  },
  resendInvitation (invitationId) {
    return Api.post(`/${resource}/${invitationId}/send`)
  },
  cancelInvitation (invitationId) {
    return Api.post(`/${resource}/${invitationId}/cancel`)
  }
}
